import { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FaCalendarCheck, FaUsers, FaSignOutAlt, FaHome, FaCog } from "react-icons/fa";

const Navbar = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    // navigate("/login");
    window.location.replace("/login");
  };

  const linkClass = ({ isActive }) =>
    `flex items-center gap-2 px-3 py-2 rounded-md text-sm transition ${
      isActive
        ? "text-blue-600 font-semibold bg-blue-50"
        : "text-gray-600 hover:text-blue-600 hover:bg-gray-50"
    }`;

  return (
    <nav className="bg-white border-b">

      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">

        {/* Logo */}
        <NavLink
          to="/dashboard"
          className="text-lg font-semibold text-gray-900"
        >
          <img src="/VideekoLogo.png" alt="VIDEEKO VANILLA" className="h-16" />
        </NavLink>

        {/* Right Menu */}
        <div className="flex items-center gap-2">

          {/* Dashboard */}
          <NavLink to="/dashboard" className={linkClass}>
            <FaHome className="text-sm" />
            Dashboard
          </NavLink>

          {/* Attendance */}
          <NavLink to="/attendance" className={linkClass}>
            <FaCalendarCheck className="text-sm" />
            Attendance
          </NavLink>

          {/* Employees */}
          <NavLink to="/employees" className={linkClass}>
            <FaUsers className="text-sm" />
            Employees
          </NavLink>

          {/* Settings */}
          <NavLink to="/settings" className={linkClass}>
            <FaCog className="text-sm" />
            Settings
          </NavLink>

          {/* Logout */}
          <button
            onClick={handleLogout}
            className="flex items-center gap-2 px-3 py-2 text-sm text-gray-600 hover:text-red-600 hover:bg-gray-50 rounded-md transition"
          >
            <FaSignOutAlt />
            Logout
          </button>

        </div>

      </div>

    </nav>
  );
};

export default Navbar;